export const PDF_LOAD_DELAY_MS = 1500;

export const RENDERABLE_FILE_TYPES = ['pdf', 'docx', 'doc', 'ppt', 'pptx'];

export const canRenderFile = (fileName: string): boolean => {
  const splitFileName = fileName.split('.');
  const fileExtension = fileName.split('.')[splitFileName.length - 1].toLowerCase();
  return RENDERABLE_FILE_TYPES.includes(fileExtension);
};
